import React from 'react'
import View from '../../../../../components/pdf/View'
import Line from '../../../../../components/pdf/Line'
import Text from '../../../../../components/pdf/Text'
import Separator from '../../../../../components/pdf/Separator'

const Introduction = () => {
  return (
    <View>
      <Separator weight={1} />

      <Line color={'#333'} height={3} />

      <Text size={30} bold>
        Introdução
      </Text>

      <Separator weight={8} />

      <View id="demand">
        <Text bold size={20}>
          DEMANDA
        </Text>
        <Separator weight={5} />
        <Text>Atendimento de legislação e melhoria nas condições de trabalho.</Text>
      </View>

      <Separator weight={8} />

      <View id="objectives">
        <Text bold size={20}>
          OBJETIVOS DA AVALIAÇÃO:
        </Text>
        <Separator weight={5} />
        <Text>
          A AET tem como objetivo identificar, analisar e classificar os fatores de riscos ergonômicos presentes nas
          atividades realizadas em cada setor de uma empresa. apresentando sua gravidade e a possibilidade de meios de
          controle.
        </Text>
      </View>

      <Separator weight={8} />

      <View id="norms">
        <Text bold size={20}>
          CONSIDERAÇÕES LEGISLATIVAS, NORMATIVAS E TÉCNICAS - CUMPRIDAS OU UTILIZADAS NA ELABORAÇÃO
        </Text>
        <Separator weight={5} />
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Lei nº 6.514 de 22 de dezembro de 1977</u>
              {
                ' que sanciona o Capítulo V do Título II da Consolidação das Leis do Trabalho, relativo à segurança e medicina do trabalho. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Portaria n° 3.214 de 08 de junho de 1978</u>
              {' que aprova as normas regulamentadoras e a Portaria N.º 3.751 de 1990 que trata da NR-17. '}
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Norma regulamentadora 17: Ergonomia</u>
              {
                ' que visa estabelecer parâmetros que permitam a adaptação das condições de trabalho às características psicofisiológicas dos trabalhadores, de modo a proporcionar um máximo de conforto, segurança e desempenho eficiente. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Norma ABNT NBR 13966/2008: móveis para escritório – mesas</u>
              {
                ' que faz a classificação, características físicas dimensionais e especifica as dimensões de mesas de escritório de uso geral, inclusive mesas de reuniões, os requisitos mecânicos, de segurança e ergonômicos para mesas de escritório, bem como define os métodos de ensaio para o atendimento destes requisitos. Os ensaios aplicam-se a móveis completos e prontos para o uso. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Norma ABNT NBR 13962/2002: móveis para escritório – cadeiras</u>
              {
                ' que especifica as características físicas e dimensionais e classifica as cadeiras para escritório, bem como estabelece os métodos para a determinação da estabilidade, da resistência e da durabilidade de cadeiras de escritório, de qualquer material. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Norma NHO 11:</u>
              {
                ' Esta NHO se aplica à avaliação do nível de iluminamento em ambientes internos. Aborda também outros aspectos e parâmetros para detecção de não conformidades que possam comprometer requisitos de segurança e desempenho eficiente do trabalho. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Norma ABNT NBR ISO 11226: Ergonomia - Avaliação de posturas estáticas no trabalho:</u>
              {
                ' Esta norma contém uma abordagem para determinar a aceitabilidade de posturas estáticas de trabalho. Especifica limites recomendados para posturas estáticas de trabalho, sem qualquer ou somente um mínimo de esforço, enquanto leva em conta aspectos como ângulos posturais e tempo. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Norma ISO 11228-1: Ergonomia - Movimentação Manual: </u>
              {
                ' Esta Parte da NBR ISO 11228 especifica os limites recomendados para o levantamento manual e transporte de cargas, levando em consideração a intensidade, a frequência e a duração da tarefa. Esta parte da NBRISO11228 foi elaborada para prover orientações para a avaliação das muitas variáveis que compõem uma tarefa, de maneira a permitir a avaliação dos riscos para a saúde dos trabalhadores. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Norma ABNT NBR ISO 11228-3: Ergonomia - Movimentação manual:</u>
              {
                ' Essa norma trata da movimentação de cargas leves em alta frequência de repetição: Esta parte da ABNT NBR ISO 11228 fornece recomendações ergonômicas para tarefas de trabalho repetitivo que envolvem movimentação manual de cargas leves em alta frequência. Ela fornece orientações sobre a identificação e avaliação de fatores de risco comumente associados à movimentação de cargas leves em alta frequência, permitindo, assim, a avaliação dos riscos de saúde relacionados à população trabalhadora. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>RULA - Rapid Upper Limb Assessment:</u>
              {
                ' método desenvolvido para avaliar a exposição dos trabalhadores a fatores de risco que podem ocasionar transtornos dos membros superiores do corpo. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>NIOSH,</u>
              {
                ' método que permite o cálculo do limite de peso a ser levantado em condições seguras pelo trabalhador. '
              }
            </li>
          </ul>
        </Text>

        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Key Indicator Method (KIM) – Levantamento e transporte manual, empurrar e puxar manualmente cargas:</u>
              {
                ' É utilizado para avaliar tarefas que envolvem operações de movimentação manual, considerando o número de levantamentos ou transporte de carga por dia de trabalho, a sua duração total no dia e a distância total percorrida no transporte da carga, o que gera uma pontuação de duração de 1 a 10. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>NASA-TLX - Task Load Index - Índice Carga Tarefa:</u>
              {
                ' Provê uma pontuação global da Carga de Trabalho baseada em uma média ponderada de avaliações em seis subescalas: exigência (demanda) mental, física, temporal, nível de realização, de esforço e de frustração. '
              }
            </li>
          </ul>
        </Text>
        <Text>
          <ul style={{ listStyleType: 'square' }}>
            <li style={{ listStylePosition: 'inside' }}>
              <u>Método OCRA (Occupational Repetitive Action):</u>
              {
                ' O Método OCRA foi desenvolvido em 1998 por Colombini, Occhipinti e Greco com o objetivo de promover a prevenção de distúrbios musculoesqueléticos de membros superiores. Esta ferramenta é aplicável a trabalhos com uma única tarefa repetitiva ou multitarefas, onde centraliza-se a análise nos membros superiores como ombro e braço (flexão, extensão e abdução), cotovelo (flexão, extensão e supinação (com a palma da mão para cima) e pronação (com a palma da mão para baixo), pulso (flexão, extensão, desvio lateral), mãos e dedos (movimento de pega). '
              }
            </li>
          </ul>
        </Text>
      </View>
    </View>
  )
}
export default Introduction
